import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getHotelsInfo } from 'httpClient/requests/searchResults';
import updateThemesAndFetchSearchResults from 'state/searchResults/operations/updateThemesAndFetchSearchResults';
import ThemeTemplateComponent from './ThemeTemplateComponent';

function ThemeTemplate({ content }) {
  const [hotels, setHotels] = useState([]);
  const destinations = useSelector((state) => state.selectDestinations.destinations);
  const dispatch = useDispatch();

  useEffect(() => {
    if (destinations.length !== 0 && hotels.length === 0) {
      const destinationsCode = destinations
        .map((country) => country.destinations.map((destination) => destination.code))
        .flat();

      getHotelsInfo({ themes: [content.theme_id], destinations: destinationsCode })
        .then((response) => {
          setHotels(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [content.theme_id, destinations, hotels]);

  function handleOnClickSeeAllHotels() {
    dispatch(updateThemesAndFetchSearchResults({ value: content.theme_id, label: content.title }));
  }

  return (
    <ThemeTemplateComponent
      content={content}
      hotels={hotels}
      showSpinner={hotels.length === 0}
      onClickSeeAllHotels={handleOnClickSeeAllHotels}
    />
  );
}

export default ThemeTemplate;
